export default "__VITE_ASSET__CDdd8gvy__"